var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContratoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 83,
    viewBox: "0 0 67 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1693 52.9247C12.4267 49.5059 14.5591 42.4796 21.0301 41.7252C29.119 40.7822 31.1995 53.0017 18.1878 48.2876C5.17604 43.5735 37.6647 57.8232 40.8365 45.6472",
    stroke: "#00D88A",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0362 12.5H8.80724C7.00185 12.5 5.2704 13.2164 3.99379 14.4916C2.71719 15.7669 2 17.4964 2 19.2999V73.699C2 75.5024 2.71719 77.232 3.99379 78.5072C5.2704 79.7824 7.00185 80.4989 8.80724 80.4989H49.6507C51.4561 80.4989 53.1875 79.7824 54.4641 78.5072C55.7407 77.232 56.4579 75.5024 56.4579 73.699V32.8997",
    stroke: "#5A57FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8056 61.0396H15.4014",
    stroke: "#ADABFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12343_16695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.375 14L53.5 6.125L56.875 2.75L64.75 10.625L61.375 14Z",
    stroke: "#00D88A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6248 7.25L46.1873 8.9375L42.2498 25.25L58.5623 21.3125L60.2498 12.875L54.6248 7.25Z",
    stroke: "#00D88A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2498 25.25L50.784 16.7157",
    stroke: "#00D88A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6252 15.125C54.6252 13.8824 53.6179 12.875 52.3752 12.875C51.1326 12.875 50.1252 13.8824 50.1252 15.125C50.1252 16.3676 51.1326 17.375 52.3752 17.375C53.6179 17.375 54.6252 16.3676 54.6252 15.125Z",
    stroke: "#00D88A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12343_16695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(40 27.5) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContratoIcon);
export default __webpack_public_path__ + "static/media/contrato-icon.b745bdfc60a9a17b11b3bd2247d78ee9.svg";
export { ForwardRef as ReactComponent };